import { request } from "@umijs/max";

export interface EmailTemplate {
  id?: number;
  name: string;
  subject: string;
  body: string;
  type?: number;
  quick_key?: string;
  body_html_url?: string;
}

export async function getEmailTemplateList(params: {
  per_page?: number;
  page?: number;
  type?: number;
  name?: string;
  quick_key?: string;
}) {
  // 默认page, 默认 per_page
  const { per_page = 10, page = 1 } = params;
  const query = {
    ...params,
    per_page,
    page,
  };
  return request("/email-template/list", {
    method: "GET",
    params: query,
  });
}

export async function getEmailTemplateUseList(params: {
  per_page?: number;
  page?: number;
  type?: number;
  name?: string;
  quick_key?: string;
}) {
  // 默认page, 默认 per_page
  const { per_page = 10, page = 1 } = params;
  const query = {
    ...params,
    per_page,
    page,
  };
  return request("/email-template/personal-list", {
    method: "GET",
    params: query,
  });
}

export async function getEmailTemplateById(params: { id: string }) {
  return request("/email-template/detail", {
    method: "GET",
    params: {
      id: params.id,
    },
  });
}

export async function addEmailTemplate(params: EmailTemplate) {
  const { type = 2 } = params;
  const query = {
    ...params,
    type,
  };
  return request("/email-template/add", {
    method: "POST",
    data: query,
  });
}

export async function updateEmailTemplate(
  params: EmailTemplate & { id: number }
) {
  return request("/email-template/update", {
    method: "POST",
    data: params,
  });
}

export async function removeEmailTemplate(params: { id: number }) {
  return request("/email-template/delete", {
    method: "POST",
    data: params,
  });
}

export async function getLabelList() {
  return request("/label/list", {
    method: "GET",
  });
}

export async function addLabel(params: { name: string }) {
  return request("/label/add", {
    method: "POST",
    data: params,
  });
}

export async function updateLabel(params: { name: string; id: number }) {
  return request("/label/update", {
    method: "POST",
    data: params,
  });
}

export async function deleteLabel(params: { id: number }) {
  return request("/label/delete", {
    method: "POST",
    data: params,
  });
}
